export const isLocalHost = (hostname: string = location.hostname): boolean =>
  ['localhost', '127.0.0.1'].includes(hostname);

const TENANT_HOST_PATTERN = /^([a-z0-9-]+)\.(dev|stage|app)\.fastr\.ai$/;

export const resolveTenant = (
  defaultTenant: string,
  hostname: string = location.hostname,
): string => {
  if (isLocalHost(hostname)) {
    return defaultTenant;
  }
  return TENANT_HOST_PATTERN.exec(hostname)?.[1] ?? defaultTenant;
};

export const toTenantUrl = (url: string, defaultTenant: string): string =>
  url.replace('TENANT', resolveTenant(defaultTenant));
